const modalidadeAssinatura = {
  MENSAL: 1,
  ANUAL: 2,

  desc: (value) => {
    switch (value) {
      case 1:
        return "Recorrente";

      case 2:
        return "Pacote adquirido";

      default:
        return "";
    }
  },
};

export default modalidadeAssinatura;
